<script setup lang="ts">
import type { Props } from 'nuxt-base/components/BaseImage.vue'

defineProps<{
  sizes: Props['sizes']
  imageTagged: gen.ImageTaggedFragment | None
}>()
const init3 = useInited('init3')
</script>

<template>
  <BaseImage lazy :img="imageTagged?.img" :sizes :ratio="imageTagged?.ratio">
    <LazyProductImageTags v-if="init3" :tags="imageTagged?.tags" />
  </BaseImage>
</template>
